import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { Feedback } from "../shared/models/feedback";
import { FeedbackService } from "../shared/services/feedback.service";
import { PlayerService } from "../shared/services/player.service";
import { Player } from "app/shared/models/player";
import { DelayedSpinnerService } from "../shared/services/delayed-spinner.service";
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { DialogService } from "../core/dialog/dialog.service";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { navigateBackOrFallback } from "../shared/screen-shell/screen-navigation.utils";

@Component({
    selector: "feedback",
    templateUrl: "./feedback.component.html",
    standalone: false
})
export class FeedbackComponent implements OnInit, OnDestroy {
  @Input() public feedback: Feedback;

  public feedbacks: Feedback[];
  public feedbackVisibility: boolean[];
  public loading = false;
  public submitting = false;
  public submitError = "";
  private readonly destroyed$ = new Subject<void>();
  public readonly feedbackReady$ = new BehaviorSubject<boolean>(false);
  public currentPlayer: Player;

  constructor(public feedbackService: FeedbackService, public playerService: PlayerService, private spinner: DelayedSpinnerService, private translate: TranslateService, private dialogService: DialogService, private location: Location, private router: Router) {}

  ngOnInit() {
    this.currentPlayer = this.playerService.getCurrentPlayer();
    this.resetFeedbackInput();
    this.getFeedback(true);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this.feedbackReady$.complete();
  }

  public onSubmit(): void {
    if (this.submitting) return;
    this.submitting = true;
    this.submitError = "";
    const release = this.spinner.acquire();
    this.feedbackService.createFeedback(this.feedback).pipe(
      takeUntil(this.destroyed$),
      finalize(() => { this.submitting = false; release(); })
    ).subscribe(
      () => {
        this.resetFeedbackInput();
        this.getFeedback();
        this.dialogService.alert({
          title: this.translate.instant('common.alert'),
          text: this.translate.instant('errors.feedbackThanks')
        });
      },
      () => { this.submitError = 'feedback.reportFailed'; }
    );
  }

  public cancelFeedback(): void {
    if (this.submitting) return;
    this.submitError = "";
    this.resetFeedbackInput();
  }

  public goBack(): void {
    navigateBackOrFallback(this.location, this.router, ["/event-list"]);
  }

  private resetFeedbackInput(): void {
    this.feedback = new Feedback(null, this.currentPlayer.email, false, "", "", true, null, 0);
  }

  public viewFeedback(id: string): void {
    this.feedbackVisibility[id] = !this.feedbackVisibility[id];
  }

  public getFeedback(initialLoad: boolean = false): void {
    let me = this;

    me.loading = true;
    if (initialLoad) {
      me.feedbackReady$.next(false);
    }
    const release = me.spinner.acquire();
    me.feedbackService.getFeedback().pipe(
      takeUntil(me.destroyed$),
      finalize(() => { me.loading = false; release(); })
    ).subscribe(
      (feedbacks) => {
        me.feedbackVisibility = new Array<boolean>(feedbacks.length);

        me.feedbacks = feedbacks;
        me.feedbackReady$.next(true);
      },
      (error) => {
        me.feedbackReady$.next(true);
      }
    );
  }
}
